import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const SuccessCircleSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 20 20",
  color = "#279B58",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm-1.458-6.396a.485.485 0 00.343-.143l5.662-5.662a.729.729 0 000-1.03l-.344-.344a.729.729 0 00-1.031 0l-4.63 4.63L6.828 9.34a.729.729 0 00-1.03 0l-.345.344a.729.729 0 000 1.031l2.745 2.745c.09.091.215.143.344.143z"
        fill={color}
      />
    </svg>
  );
};

export { SuccessCircleSvg };
